import axios from '../../../../services/api';
import { kanbanUrls } from '../apiUrls';
import { fetchUserRoles } from '../../helpers/userHelper';

const fetchRequiredRoles = async (action: string, pageKey?: string): Promise<string[]> => {
  try {
    const requiredRolesResponse = await axios.get(kanbanUrls.getKanbanPermissionsForPhase, {
      params: { nodeKey: pageKey },
    });

    const permissions: { [key: string]: string } = requiredRolesResponse?.data?.data;

    if (!permissions || !permissions[action]) {
      return [];
    }

    const requiredPermissionString = permissions[action];

    return requiredPermissionString
      ? requiredPermissionString.split(',').map((role) => role.trim().toLowerCase())
      : [];
  } catch (error) {
    console.error('Error fetching required roles', error);
    return [];
  }
};

const hasPermission = (userRoles: string[], requiredRoles: string[]): boolean => {
  return userRoles.some((role) => requiredRoles.includes(role));
};

export const checkPermission = async (action: string, pageKey?: string): Promise<boolean> => {
  try {
    const userRoles = await fetchUserRoles();
    if (userRoles.length === 0) return false;

    const requiredRoles = await fetchRequiredRoles(action, pageKey);
    if (requiredRoles.length === 0) return false;

    return hasPermission(userRoles, requiredRoles);
  } catch (error) {
    console.error('Error checking permissions', error);
    return false;
  }
};

export const fetchBoardVisibleRoles = async (pageKey?: string): Promise<string[]> => {
  try {
    const response = await axios.get(kanbanUrls.getBoardVisibilityRoles, {
      params: { nodeKey: pageKey },
    });

    const visibleRolesString = response?.data?.data?.VisibleForRoles || '';

    return visibleRolesString
      .split(',')
      .map((role: string) => role.trim().toLowerCase())
      .filter(Boolean);
  } catch (error) {
    console.error('Error fetching board visible roles', error);
    return [];
  }
};

export const checkBoardAccess = async (pageKey?: string): Promise<boolean> => {
  try {
    const userRoles = await fetchUserRoles();
    if (userRoles.length === 0) return false;

    const visibleRoles = await fetchBoardVisibleRoles(pageKey);
    if (visibleRoles.length === 0) return true;

    return hasPermission(userRoles, visibleRoles);
  } catch (error) {
    console.error('Error checking board access', error);
    return false;
  }
};
